import { render, staticRenderFns } from "./EditCompanyButton.vue?vue&type=template&id=ff33f7f8&"
import script from "./EditCompanyButton.vue?vue&type=script&lang=js&"
export * from "./EditCompanyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports